

const Fruits = [
    {name: "CHERRY", radius: 12 , color: '#860707'},
    {name: "STRAWBERRY", radius: 15 , color:'#F05050'},
    {name: "GRAPE", radius: 25 , color:'#8B34F2'},
    {name: "MANDARIN", radius: 27 , color:'#FABC47'},
    {name: "ORANGE", radius: 35 , color:'#FF7800'},
    {name: "APPLE", radius: 43 , color:'#FF0000'},
    {name: "GOLDENAPPLE", radius: 50 , color:'#FBFF00'},
    {name: "PEACH", radius: 62, color:'#FF9B9E'},
    {name: "PINEAPPLE", radius: 68, color:'#FFE700'},
    {name: "MELON", radius: 83 , color:'#83FF00'},
    {name: "WATERMELON", radius: 100 , color:'#39A300'},
];

const Modes = [
    {mode: "NORMAL", mass: 0.05, restitution: 0.5, friction: 0},
    {mode: "JELLY", mass: 0.05, restitution: 0.5, friction: 0},
];



export default Fruits